import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const categoriasRoutes: Routes = [
  {
    path: 'categorias',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./categorias.component').then((m) => m.CategoriasComponent),
        data: {
          title: 'Gerenciar Categorias',
          roles: [Role.CATEGORIA_CONSULTAR],
          breadcrumb: [{ label: 'Categoria', url: '/categorias' }],
        },
      },
      {
        path: 'cadastrar',
        loadComponent: () =>
          import('./categoria-form/categoria-form.component').then(
            (m) => m.CategoriaFormComponent,
          ),
        data: {
          title: 'Gerenciar Categorias',
          roles: [Role.CATEGORIA_CADASTRAR],
          breadcrumb: [
            { label: 'Categoria', url: '/categorias' },
            { label: 'Cadastrar', url: '/categorias/cadastrar' },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./categoria-form/categoria-form.component').then(
            (m) => m.CategoriaFormComponent,
          ),
        data: {
          title: 'Gerenciar Categorias',
          roles: [Role.CATEGORIA_EDITAR],
          breadcrumb: [
            { label: 'Categoria', url: '/categorias' },
            { label: 'Editar', url: '/categorias/editar' },
          ],
        },
      },
    ],
  },
];
